import SettingsLayout from "@/components/SettingsLayout";
import { SettingsList, SettingsListItem } from "@/components/SettingsList";
import { formatTimestamp } from "@/lib/dates";
import { csrfToken } from "@/lib/fetchSideEffect";

interface Link {
  username: string | null;
  linked_at: string;
}

export default function SettingsTelegram({
  link,
  botConfigured,
}: {
  link: Link | null;
  botConfigured: boolean;
}) {
  return (
    <SettingsLayout active="telegram" title="Telegram">
      <p className="text-sm text-gray-500">
        Привяжи аккаунт Telegram и отправь боту любое сообщение — оно попадёт задачей во «Входящее».
      </p>

      {link ? (
        <SettingsList>
          <SettingsListItem
            title={`Привязано${link.username ? ` как @${link.username}` : ""} ✓`}
            meta={<>Привязано {formatTimestamp(link.linked_at)}</>}
            action={
              <form method="POST" action="/settings/telegram_link">
                <input type="hidden" name="authenticity_token" value={csrfToken()} />
                <input type="hidden" name="_method" value="delete" />
                <button type="submit" className="text-sm text-red-600 hover:text-red-700">
                  Отвязать
                </button>
              </form>
            }
          />
        </SettingsList>
      ) : !botConfigured ? (
        <p className="text-sm text-amber-600">
          Бот Telegram ещё не настроен на этом сервере.
        </p>
      ) : (
        <form method="POST" action="/settings/telegram_link">
          <input type="hidden" name="authenticity_token" value={csrfToken()} />
          <button
            type="submit"
            className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-md font-medium"
          >
            Привязать Telegram
          </button>
        </form>
      )}
    </SettingsLayout>
  );
}
